"use client";

// import Link from "next/link";
import { Button, buttonVariants } from "@/components/ui/button";
import { Add, Message } from "iconsax-react";
import Notification from "./Notification";
import { TNotification, TResponseServerAction, TRole } from "@/actions/types";
import { SupportedLanguage } from "@/lib/shared";
import lang from "./lang.json";
import { TUser } from "@/actions/types";
import ProfileMenu from "./ProfileMenu";
import MobileProfileContent from "./MobileProfileContent";
import { useState } from "react";
import CreateNewPostDialog from "@/components/customs/Posts/CreateNewPostDynamic";
import { useIsMobile } from "@/hooks/use-mobile";
import { Link } from "react-router-dom";
import { localizedPath } from "@/lib/localePath";

type ProfileContentProps = {
  profile?: TUser;
  unreadCounter: TResponseServerAction<{ unread_count: number }>;
  notifications: TResponseServerAction<TNotification[]>;
  unreadMessageCount: number;
  locale: SupportedLanguage;
  session?: string;
  role: TRole;
};

export default function ProfileContent({
  unreadCounter,
  notifications,
  locale,
  profile,
  // unreadMessageCount,
  session,
  role,
}: ProfileContentProps) {
  const [isCreatePostOpen, setIsCreatePostOpen] = useState<boolean>(false);
  const isMobile = useIsMobile();
  return (
    <>
      <span className="items-center gap-x-2 flex">
        {/* <Link
          href="/me/favorites"
          className={buttonVariants({
            variant: "link",
            className: "!px-2 !hidden md:!flex",
          })}
        >
          <Heart variant="Outline" className="fill-current" />
        </Link> */}

        <Link
          to={localizedPath(locale, "/me/conversations")}
          className={buttonVariants({
            variant: "link",
            size: "icon-lg",
            className: "!p-2 relative h-auto !hidden md:!flex",
          })}
        >
          <Message variant="Outline" className="fill-current" />
          {/* {unreadMessageCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-primary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {unreadMessageCount}
            </span>
          )} */}
        </Link>

        <Notification
          count={
            unreadCounter.status === "success"
              ? unreadCounter.metaData.unread_count
              : 0
          }
          notifications={
            notifications.status === "success" ? notifications.metaData : []
          }
          locale={locale}
        />
      </span>

      <Button
        variant="default"
        size={isMobile ? "default" : "xl"}
        rounded="full"
        onClick={() => setIsCreatePostOpen(true)}
      >
        <Add variant="Outline" className="fill-current" />{" "}
        <span className="!hidden md:!flex">
          {lang["add-posts"][locale] || "Add Posts"}
        </span>
      </Button>

      {isCreatePostOpen ? (
        <CreateNewPostDialog
          type="video"
          open
          onOpenChange={setIsCreatePostOpen}
          accountType={role}
          companyProfileId={profile?.id}
          locale={locale}
        />
      ) : null}

      <div className="inline-flex md:hidden">
        <MobileProfileContent
          locale={locale}
          avatarSrc={profile?.image ?? undefined}
          name={profile?.name}
          userId={profile?.id}
          session={session}
          role={role}
        />
      </div>
      <div className="hidden md:inline-flex">
        <ProfileMenu
          locale={locale}
          avatarSrc={profile?.image ?? undefined}
          name={profile?.name}
          userId={profile?.id}
          session={session}
          role={role}
        />
      </div>
    </>
  );
}
